// LeaderboardUserCard.js
import { connect } from 'react-redux';
import LeaderboardUserCard from '../component/LeaderboardUserCard.jsx';
import getUserData from '../selector/getUserData.js';
import fetchUser from '../action/fetchUser.js';

const mapStateToProps = (state, { userId }) => {
  return {
    username: getUserData(state, userId, 'username'),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchUser: userId => dispatch(fetchUser({ id: userId })),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LeaderboardUserCard);
